import React from 'react';

const JobBreakdownTable = ({ jobs, type }) => {
	if (!jobs || jobs.length === 0) {
		return (
			<div className="alert alert-info small">
				No {type} jobs executed for this property.
			</div>
		);
	}

	return (
		<div className="table-responsive">
			<table className="table table-sm table-hover">
				<thead className="table-light">
					<tr>
						<th>Job Type</th>
						<th className="text-center">Executions</th>
						<th className="text-center">Successes</th>
						<th className="text-center">Failures</th>
						<th className="text-center">Success Rate</th>
					</tr>
				</thead>
				<tbody>
					{jobs.map((job, index) => (
						<tr key={index}>
							<td>
								<code className="small">{job.jobClass}</code>
							</td>
							<td className="text-center">
								<span className="badge bg-primary">{job.executions}</span>
							</td>
							<td className="text-center">
								<span className="badge bg-success">{job.successes}</span>
							</td>
							<td className="text-center">
								{job.failures > 0 ? (
									<span className="badge bg-danger">{job.failures}</span>
								) : (
									<span className="text-muted">0</span>
								)}
							</td>
							<td className="text-center">
								<span
									className={`badge ${
										job.successRate >= 95
											? 'bg-success'
											: job.successRate >= 80
												? 'bg-warning'
												: 'bg-danger'
									}`}
								>
									{job.successRate}%
								</span>
							</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
};

export default JobBreakdownTable;
